<template>
    <div class="animated fadeIn">
        <component-new-header
            :title="
                $route.params.id && partnerAllData
                    ? `${partnerAllData.authentication.userName} - Partners`
                    : 'Partners'
            "
            @search-query="(val) => (search = val)"
            @select-query="selectPartnerType"
            :selectedOption="selectedFilter"
            :isLoading="loading"
            @reload-data="reloadData"
            @create-press="createPartner"
            createButtonText="Create Partner"
            :hasCreate="!$route.params.id"
            :hasback="false"
            :hasDropdown="true"
            :hasfilterOptions="filterOptions"
            @back-press="$router.push('/partner/view')"
        />
        <b-card class="card-wrap" border-variant="info">
            <b-row v-if="$currentUserData.category != 'SELLER'">
                <b-col md="9"></b-col>
                <b-col md="3" class="float-right">
                    <!-- <eb-select
              :options="filterOptions"
              :selected="selectedFilter.text"
              @input="onChangeFilter"
              id="value"
              type="text"
              text="text"
            ></eb-select> -->
                </b-col>
            </b-row>
            <div class="text-center" v-if="loading">
                <p>
                    <b>Loading....</b>
                </p>
            </div>
            <div v-if="!loading">
                <div class="">
                    <b-table
                        class="table-border-radius professional-stacked-table"
                        id="partner-table"
                        :hover="true"
                        :dark="false"
                        :striped="false"
                        :bordered="false"
                        :small="false"
                        :fixed="false"
                        responsive
                        stacked="md"
                        :items="filteredList"
                        :fields="partnerColumns"
                        :per-page="perPage"
                        filter
                        thead-class="header"
                        show-empty
                        :busy="loading"
                    >
                        <template slot="cell(logo)" slot-scope="data">
                            <v-avatar size="60">
                                <img
                                    :src="
                                        data.item && data.item.organization && data.item.organization.logo && data.item.organization.logo.url &&
                                        isUrlValid(
                                            data.item.organization.logo.url,
                                        )
                                            ? data.item.organization.logo.url
                                            : 'img/avatars/6.jpg'
                                    "
                                />
                            </v-avatar>
                        </template>

                        <template slot="cell(action)" slot-scope="data">
                            <div class="inline_btnTable">
                                <ActionButtonGroup
                                    showView
                                    showDelete
                                    @view="viewPartner(data.item)"
                                    @delete="deletepartner(data.item)"
                                />
                            </div>
                        </template>
                    </b-table>
                    <i-delete
                        ref="delete-comp"
                        @proceed-delete="deleteEvent"
                    ></i-delete>
                </div>
                <div class="pagination-wrapper">
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="partnerListMeta.total"
                        aria-controls="partner-table"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons
                        @change="getPartnerData"
                    ></b-pagination>
                </div>
            </div>
        </b-card>
    </div>
</template>
<script>
import ebButton from "@/components/FormElements/Button";
import ComponentNewHeader from "@/components/componentNewHeader";
import ebSelect from "@/components/FormElements/Select.vue";
import iDelete from "@/components/DeleteConfirm/ItemDelete.vue";
import cInput from "@/components/FormElements/CustomInput";
import { mapActions, mapGetters, mapState } from "vuex";
import ActionButtonGroup from "@/components/Common/ActionButtonGroup.vue";
export default {
    name: "viewattribute",
    components: {
        ebButton,
        ebSelect,
        cInput,
        iDelete,
        ComponentNewHeader,
        ActionButtonGroup,
    },
    data() {
        return {
            partner: {},
            loading: false,
            currentPage: 1,
            search: "",
            selectedOption: "",
            perPage: 10,
            confirmation: "",
            selectedPartnerId: null,
            selectedFilter: "SELLER",
            partnerColumns: [
                {
                    key: "logo",
                },
                {
                    key: "userName",
                },
                {
                    key: "email",
                },
                {
                    key: "phone",
                },
                {
                    key: "type",
                },
                {
                    key: "action",
                    thStyle: { minWidth: "120px" },
                },
            ],
        };
    },
    computed: {
        ...mapState({
            partnerListMeta: (state) => state.partner.partnerListMeta,
        }),
        filterOptions() {
            if (this.$currentUserData.category === "DISTRIBUTOR") {
                return [
                    { text: "SELLER", value: "SELLER" },
                    { text: "DEALER", value: "DEALER" },
                    { text: "SUB_DEALER", value: "SUB_DEALER" },
                    { text: "OFFICE", value: "OFFICE" },
                    { text: "SUPPLIER", value: "SUPPLIER" },
                ];
            } else if (this.$currentUserData.category === "DEALER") {
                return [
                    { text: "SELLER", value: "SELLER" },
                    { text: "SUB DEALER", value: "SUB_DEALER" },
                ];
            } else if (this.$currentUserData.category === "SUB_DEALER") {
                return [{ text: "SELLER", value: "SELLER" }];
            } else {
                return [
                    { text: "DISTRIBUTOR", value: "DISTRIBUTOR" },
                    { text: "SELLER", value: "SELLER" },
                    { text: "DEALER", value: "DEALER" },
                    { text: "SUB_DEALER", value: "SUB_DEALER" },
                    { text: "OFFICE", value: "OFFICE" },
                    { text: "SUPPLIER", value: "SUPPLIER" },
                    { text: "MANUFACTURER", value: "MANUFACTURER" },
                ];
            }
        },
        ...mapGetters({ partnerAllData: "partner/GetPartnerData" }),
        filteredList() {
            let data = this.partners.filter((partner) => {
                const userNameMatch = partner.authentication.userName
                    .toLowerCase()
                    .includes(this.search.toLowerCase());
                const emailMatch = partner.authentication.email
                    .toLowerCase()
                    .includes(this.search.toLowerCase());
                return userNameMatch || emailMatch;
            });
            return data.sort(
                (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt),
            );
        },
        partners() {
            let data = this.$store.getters["partner/GetPartnerList"];
            let partnerList = [];
            if (Array.isArray(data) && data.length > 0) {
                data.map((obj) => {
                    if (obj.category != "STOCK_POINT") {
                        let arrayObj = {
                            logo: obj.organization && obj.organization.logo && obj.organization.logo.url ? obj.organization.logo.url : '',
                            _id: obj._id,
                            userName: obj.authentication.userName,
                            email: obj.authentication.email,
                            phone: obj.authentication.phone,
                            type: obj.category,
                            ...obj,
                        };
                        partnerList.push(arrayObj);
                    }
                });
                return partnerList.sort(
                    (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt),
                );
            } else {
                return [];
            }
        },
    },
    watch: {
        search(value) {
            this.currentPage = 1;
        },
    },
    methods: {
        ...mapActions({
            Getpartnerlist: "partner/fetchPartnersList",
            Getchildpartnerlist: "partner/fetchChildPartnersList",
        }),
        async reloadData() {
            this.loading = true;
            await this.getPartnerListData();
        },
        // onChangeFilter(e) {
        //   this.selectedFilter = e;
        // },
        editTenant(data) {
            this.$store.dispatch("partner/editPartnerData", data);
            this.$router.push("/partner/view");
        },
        viewPartner(data) {
            this.$store.dispatch("partner/editPartnerData", data);
            this.$router.push({ name: "basic-info", params: { id: data._id } });
        },

        createPartner() {
            this.$router.push({
                path: "/partner/create",
                query: { partner: true },
            });
        },
        async getPartnerData(e) {
            this.currentPage = e;
            await this.getPartnerListData();
        },
        selectPartnerType(val) {
            this.selectedFilter = val;
            this.getPartnerListData();
        },
        getPartnerListData() {
            this.loading = true;
            const payload = {
                limit: this.perPage,
                page: this.currentPage,
                category: this.selectedFilter,
            };
            if (
                this.$route.params.id ||
                this.$currentUserData.category !== "TA"
            ) {
                payload.parentId =
                    this.$route.params.id ||
                    this.$store.getters["auth/getUserID"];
            }
            this.Getpartnerlist(payload).then((data) => {
                if (data.message) {
                    this.$toasted.error(data.message);
                    this.loading = false;
                }
                this.loading = false;
            });
            //  this.$router.push("/partner");
        },
        getChildPartnerListData() {
            this.loading = true;
            let parentId = this.$route.params.id;
            this.Getchildpartnerlist(parentId).then((data) => {
                if (data.message) {
                    this.$toasted.error(data.message);
                    this.loading = false;
                }
                this.loading = false;
            });
        },
        isUrlValid(userInput) {
            try {
                var res = userInput.match(
                    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g,
                );
                if (res == null) return false;
                else return true;
            } catch (err) {}
        },
        deletepartner(data) {
            this.$refs["delete-comp"].openModal();
            this.selectedPartnerId = data._id;
        },
        async deleteEvent() {
            await this.$store
                .dispatch("partner/deletePartner", this.selectedPartnerId)
                .then((result) => {
                    this.$toasted.success("Partner Deleted Successfully");
                    this.getPartnerListData();
                })
                .catch((error) => {
                    this.$toasted.error(error.message);
                });
        },
    },
    async mounted() {
        this.loading = true;
        await this.getPartnerListData();
        this.$store.dispatch("partner/editPartnerData", null);
    },
};
</script>

<style scoped>
::v-deep #partner-table .b-table-empty-row td {
    text-align: center !important;
}

.item-card {
    width: 340px;
    height: 175px;
    max-height: 200px;
    background: #ffffff;
    border: 1px solid #ececec;
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    padding: 2px;
}

.font {
    font-size: 15px;
}
.edit {
    color: white !important;
}
.text-center {
    text-align: center;
}
.text-width {
    width: 90px;
}
.form-div text {
    margin-top: 8px;
}

.table-border-radius {
    border-radius: 12px;
}

.pagination-wrapper {
    float: right;
}

@media (max-width: 767.98px) {
    .pagination-wrapper {
        float: none;
        text-align: center;
        margin-top: 1rem;
    }
}
</style>
